import { render, staticRenderFns } from "./FaceDetectionOverlay.vue?vue&type=template&id=0944ab9b&scoped=true"
import script from "./FaceDetectionOverlay.vue?vue&type=script&lang=js"
export * from "./FaceDetectionOverlay.vue?vue&type=script&lang=js"
import style0 from "./FaceDetectionOverlay.vue?vue&type=style&index=0&id=0944ab9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944ab9b",
  null
  
)

export default component.exports